export default __webpack_public_path__ + "images/0xd4aa386bfceeedd9de0875b3ba07f51808592e22.png";